import type { Follow } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { defaultFollow } from "./defaultFollow"
import { usePolyglot } from "src/contexts/PolyglotContext"
import { useAccount } from "src/hooks/account"

export function useDefaultFollow(): Follow {
  const { data: account } = useAccount()
  const accountId = account?.id

  const localization = usePolyglot()

  return useMemo(
    () => ({
      ...defaultFollow,
      account_id: accountId ?? defaultFollow.account_id,
      nickname: localization.t("components.page_header.default_user_name"),
    }),
    [
      accountId,
      localization,
    ],
  )
}
